import React, { Component } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';

import Logo from './../lib/Logo/Logo';
import { Button, TextInput } from './../lib/index';

const RootContainer = styled.div`
  display: flex;
  background-color: #f2c96d;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

const CardContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px #888888;
  flex-direction: column;
  max-width: 400px;
  padding: 20px;
  width: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

class Login extends Component {
  constructor() {
    super();
    this.state = { email: '', password: '' };
  }

  handleTextInput = (e, name) => {
    console.log('e', e);

    this.setState({ [name]: e.target.value });
  };

  render() {
    const { isAuth, loginUser } = this.props;
    if (isAuth) {
      return <Redirect to="/" />;
    }
    return (
      <RootContainer>
        <CardContainer>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          <TextInputContainer>
            <TextInput
              value={this.state.email}
              onChange={e => this.handleTextInput(e, 'email')}
              type="text"
              title="Email address"
            ></TextInput>
            <TextInput
              value={this.state.password}
              onChange={e => this.handleTextInput(e, 'password')}
              type="password"
              title="Password"
            ></TextInput>
            <Button
              title="Login"
              onClick={() => loginUser(this.state.email, this.state.password)}
            ></Button>
          </TextInputContainer>
        </CardContainer>
      </RootContainer>
    );
  }
}
export default Login;
